import type { ActiveAssetRef } from "@elaso/shared/schemas/active-assets";
import { useEffect } from "react";
import { acquireActiveAsset, releaseActiveAsset } from "@/lib/active-assets";

/**
 * Register the enclosing component as a mounted FULL VIEW of the asset for the
 * live-lesson delivery tier (docs/adr/23-the-live-lesson-delivery-tier.md).
 * While it is mounted, the server delivers viewer-only events, typing today, for
 * this asset to the connection. Call it from components that render an asset as
 * a primary pane, a channel view or a thread panel, and never from previews,
 * peeks or list rows.
 */
export function useActiveAsset(
	type: ActiveAssetRef["type"],
	id: string | undefined
): void {
	useEffect(() => {
		if (!id) {
			return;
		}
		const ref = { type, id };
		acquireActiveAsset(ref);
		return () => releaseActiveAsset(ref);
	}, [type, id]);
}
